import { render } from "./M0.vue?vue&type=template&id=21165a12&scoped=true"
import script from "./M0.vue?vue&type=script&lang=js"
export * from "./M0.vue?vue&type=script&lang=js"

import "./M0.vue?vue&type=style&index=0&id=21165a12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21165a12"]])

export default __exports__